/**
 * @name 无需服务端获取的微应用
 */

export const noAuthApps = [
  {
    name: "auth",
    defaultRegister: true,
    routerBase: "/auth",
    entry: "/appAuth/",
    entryDev: "//localhost:9001/appAuth/",
  },
];

export const appList = [
  // {
  //   name: 'articles', // 物品放行vue2.0
  //   routerBase: '/articles', // 子应用激活的规则（会根据路由进行匹配）
  //   defaultRegister: false,
  //   entry: '/articles/',
  //   entryDev: '//localhost:9003/articles/'
  // },
  {
    name: "mRreleaseArticles", // 子应用的名字 - 物品放行
    routerBase: "/mRreleaseArticles", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appFrontRelease/",
    entryDev: "//localhost:9003/appFrontRelease/",
  },

  {
    name: "systemSetting", // 子应用的名字
    routerBase: "/systemSetting", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appSystemSetting/",
    entryDev: "//localhost:9003/appSystemSetting/",
  },
  {
    name: "personAccess", // 子应用的名字
    routerBase: "/personAccess", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appPersonaccess/",
    entryDev: "//localhost:9005/appPersonaccess/",
  },
  {
    name: "patrol", // 子应用的名字
    routerBase: "/patrol", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appSecurityProtection/",
    entryDev: "//localhost:9006/appSecurityProtection/",
  },
  {
    name: "electFence", // 子应用的名字
    routerBase: "/electFence", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appElectronicFence/",
    entryDev: "//localhost:9007/appElectronicFence/",
  },
  {
    name: "workorder", // 子应用的名字
    routerBase: "/workorder", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appWorkorderManagement/",
    entryDev: "//localhost:9008/appWorkorderManagement/",
  },
  {
    name: "safePoll", // 子应用的名字
    routerBase: "/safePoll", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appSecurityPoll/",
    entryDev: "//localhost:9009/appSecurityPoll/",
  },
  {
    name: "warningCentre", // 子应用的名字
    routerBase: "/warningCentre", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appWarningCentre/",
    entryDev: "//localhost:9010/appWarningCentre/",
  },
  {
    name: "interCom", // 子应用的名字
    routerBase: "/interCom", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appIntercomSystem/",
    entryDev: "//localhost:9090/appIntercomSystem/",
  },
  {
    name: "home", // 子应用的名字
    routerBase: "/main", // 子应用激活的规则（会根据路由进行匹配）
    // defaultRegister: false,
    defaultRegister: true,
    entry: "/appHome/",
    entryDev: "//localhost:9011/appHome/",
  },
  {
    name: "alarmManagement", // 预警中心-告警管理
    routerBase: "/alarmManagement", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appAlarmManagement/",
    entryDev: "//localhost:9012/appAlarmManagement/",
  },
  {
    name: "decorate-mgt", // 装修申请子应用
    routerBase: "/decorateMenu",
    defaultRegister: false,
    entry: "/appDecoratemgt/",
    entryDev: "//localhost:9013/appDecoratemgt/",
  },
  {
    name: "business-management", // 公司管理/员工管理 子应用
    routerBase: "/businessManagement",
    defaultRegister: false,
    entry: "/appBusinessManagement/",
    entryDev: "//localhost:9024/appBusinessManagement/",
  },
  {
    name: "questionnaire", // 园区运营-问卷调查
    routerBase: "/questionnaire", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appQuestionnaire/",
    entryDev: "//localhost:9017/appQuestionnaire/",
  },
  {
    name: "parkOperation", // 园区运营-信息发布
    routerBase: "/parkOperation", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appParkOperation/",
    entryDev: "//localhost:9019/appParkOperation/",
  },
  {
    name: "householdManagement", // 住户管理
    routerBase: "/householdManagement", // 子应用激活的规则（会根据路由进行匹配）npm
    defaultRegister: false,
    entry: "/appHouseholdManagement/",
    entryDev: "//localhost:9018/appHouseholdManagement/",
  },
  {
    name: "onlineService", // 在线客服
    routerBase: "/onlineService", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appOnlineService/",
    entryDev: "//localhost:9026/appOnlineService/",
  },
  {
    name: "alarmMap", // 告警地图
    routerBase: "/alarmMap", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appAlarmMap/",
    entryDev: "//localhost:9027/appAlarmMap/",
  },
  {
    name: "deviceManage", // 设备管理
    routerBase: "/deviceManage", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appDevicemanage/",
    entryDev: "//localhost:9013/appDevicemanage/",
  },
  {
    name: "statistics", // 设备管理
    routerBase: "/statistics", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appStatistics/",
    entryDev: "//localhost:9028/appStatistics/",
  },
  {
    name: "carRelease", // 车行
    routerBase: "/carRelease", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appCarRelease/",
    entryDev: "//localhost:9020/appCarRelease/",
  },
  {
    name: "financialManagement", // 业财管理
    routerBase: "/financialManagement", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appFinancialManagement/",
    entryDev: "//localhost:9025/appFinancialManagement/",
  },
  {
    name: "energyConsumption", // 能耗管理
    routerBase: "/energyConsumption", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appEnergyConsumption/",
    entryDev: "//localhost:9029/appEnergyConsumption/",
  },
  {
    name: "discharged", // 物品放行
    routerBase: "/discharged", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appDischarged/",
    entryDev: "//localhost:9014/appDischarged/",
  },
  {
    name: "businessOpportManage", // 子应用的名字
    routerBase: "/businessOpportManage",
    entry: "/appBusinessOpportManage/", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entryDev: "//localhost:9014/appBusinessOpportManage/",
  },
  {
    name: "investmentManagement", // 子应用的名字
    routerBase: "/investmentManagement", // 子应用激活的规则（会根据路由进行匹配）
    entry: "/appInvestmentManagement/",
    defaultRegister: false,
    entryDev: "//localhost:9014/appInvestmentManagement/",
  },
  {
    name: "org", // ifm企业管理
    routerBase: "/org", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appOrg/",
    entryDev: "//localhost:9027/appOrg/",
  },
  {
    name: "ifmsys", // ifm超管后台
    routerBase: "/ifmsys", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appIfmsys/",
    entryDev: "//localhost:9026/appIfmsys/",
  },
  {
    name: "ifmPa", // ifm人员管理
    routerBase: "/ifmPa", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appIfmPa/",
    entryDev: "//localhost:9030/appIfmPa/",
  },
  {
    name: "ifmAsset", // ifm资产管理
    routerBase: "/ifmAsset", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appIfmAsset/",
    entryDev: "//localhost:9040/appIfmAsset/",
  },
  {
    name: "ifmKbm", // ifm知识库
    routerBase: "/ifmKbm", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appIfmKbm/",
    entryDev: "//localhost:9050/appIfmKbm/",
  },
  {
    name: 'zhcfStaticPage',                 // 城服静态页面
    routerBase: '/zhcfStaticPage',         // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: '/appZhcfStaticPage/',
    entryDev: '//localhost:9064/appZhcfStaticPage/'
  },
  {
    name: "ifmPm", // ifm保养管理
    routerBase: "/ifmPm", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appIfmPm/",
    entryDev: "//localhost:9062/appIfmPm/",
  },
  {
    name: "ifmInspectionManage", // ifm巡检管理
    routerBase: "/ifmInspectionManage", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appIfmInspectionManage/",
    entryDev: "//localhost:9061/appIfmInspectionManage/",
  },
  {
    name: "ifmDeviceReport", // ifm设备报表
    routerBase: "/ifmDeviceReport", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appIfmDeviceReport/",
    entryDev: "//localhost:9063/appIfmDeviceReport/",
  },
  {
    name: "cloudTest", // 云测
    routerBase: "/cloudTest", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appCloudTest/",
    entryDev: "//localhost:9060/appCloudTest/",
  },
  {
    name: "guardEmploy", // 物品放行
    routerBase: "/guardEmploy", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appGuardEmploy/",
    entryDev: "//localhost:9999/appGuardEmploy/",
  },
  // {
  //   name: 'guardAttendance', // 考勤中台
  //   routerBase: '/guardAttendance', // 子应用激活的规则（会根据路由进行匹配）
  //   defaultRegister: false,
  //   entry: '/appGuardAttendance/',
  //   entryDev: '//localhost:9989/appGuardAttendance/'
  // },
  {
    name: "smartLighting", // 子应用的名字
    routerBase: "/smartLighting", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appSmartLighting/",
    entryDev: "//localhost:9015/appSmartLighting/",
  },
  {
    name: "jinmao", // 金茂业态
    routerBase: "/jinmao", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appJinmaoChild/",
    entryDev: "//localhost:9002/appJinmaoChild/",
  },
  {
    name: "environment", // 环境报表
    routerBase: "/environment", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appEnvironment/",
    entryDev: "//localhost:9030/appEnvironment/",
  },
  {
    name: "upgrade", // 升级模块
    routerBase: "/upgrade", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appUpgrade/",
    entryDev: "//localhost:9039/appUpgrade/",
  },
  {
    name: "smartHomeAdmin", // 升级模块
    routerBase: "/smartHomeAdmin", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appSmartHomeAdmin/",
    entryDev: "//localhost:9041/appSmartHomeAdmin/",
  },
  {
    name: "attendance", // 考勤模块
    routerBase: "/guardAttendance", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appGuardAttendance/",
    entryDev: "//localhost:9989/appGuardAttendance/",
  },
  {
    name: "knowledge", // 智能客服 知识库
    routerBase: "/knowledge", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appKnowledge/",
    entryDev: "//localhost:9036/appKnowledge/",
  },
  {
    name: "iotAdmin", // 子应用的名字
    routerBase: "/iotAdmin",
    defaultRegister: false,
    entry: "/appIotAdmin/",
    entryDev: "//localhost:9801/appIotAdmin/",
  },
  {
    name: "propertyEvaluation", // 物业评价
    routerBase: "/propertyEvaluation",
    defaultRegister: false,
    entry: "/appPropertyEvaluation/",
    entryDev: "//localhost:9069/appPropertyEvaluation/",
  },
  {
    name: "processConfig", // 业务流程配置
    routerBase: "/processConfig",
    defaultRegister: false,
    entry: "/appApprovalManagement/",
    entryDev: "//localhost:9040/appApprovalManagement/",
  },
  {
    name: "approvalManagement", // 审批管理
    routerBase: "/approvalManagement", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appApprovalManagement/",
    entryDev: "//localhost:9040/appApprovalManagement/",
  },
  {
    name: "visualConfig", // App可视化配置
    routerBase: "/visualConfig",
    defaultRegister: false,
    entry: "/appVisualConfig/",
    entryDev: "//localhost:9093/appVisualConfig/",
  },
  {
    name: "meeting", // 会议管理
    routerBase: "/meeting",
    defaultRegister: false,
    entry: "/appMeeting/",
    entryDev: "//localhost:9042/appMeeting/",
  },
  {
    name: "fireProtection", // 消防管理
    routerBase: "/fireProtection",
    defaultRegister: false,
    entry: "/appFireProtection/",
    entryDev: "//localhost:9119/appFireProtection/",
  },
  {
    name: "operationsManagement", //运营管理
    routerBase: "/operationsManagement",
    defaultRegister: false,
    entry: "/appOperationsManagement/",
    entryDev: "//localhost:9016/appOperationsManagement/",
  },
  {
    name: "iotProjectDevices",
    routerBase: "/iotProjectDevices",
    defaultRegister: false,
    entry: "/appIotProjectDevices/",
    entryDev: "//localhost:9805/appIotProjectDevices/",
  },
  // 添加场景管理子应用入口
  {
    name: "iotScene",
    routerBase: "/iotScene",
    defaultRegister: false,
    entry: "/appIotSceneManage/",
    entryDev: "//localhost:9802/appIotSceneManage/",
  },
  {
    name: "dynamicForm", // 动态表单
    routerBase: "/dynamicForm",
    defaultRegister: false,
    entry: "/appDynamicForm/",
    entryDev: "//localhost:9070/appDynamicForm/",
  },
  {
    name: "virtualManagement", // VR管理
    routerBase: "/virtualManagement",
    defaultRegister: false,
    entry: "/appVirtualManagement/",
    entryDev: "//localhost:9527/appVirtualManagement/",
  },
  {
    name: "fireProtectionZKTL", // 中科图灵 --- 消防管理
    routerBase: "/fireProtectionZKTL",
    defaultRegister: false,
    entry: "/appFireProtectionZKTL/",
    entryDev: "//localhost:9080/appFireProtectionZKTL/",
  },
  {
    name: "serviceAlliance", //服务联盟
    routerBase: "/serviceAlliance",
    defaultRegister: false,
    entry: "/appServiceAlliance/",
    entryDev: "//localhost:9101/appServiceAlliance/",
  },
  {
    name: "officeSamrtControl", //办公智控
    routerBase: "/officeSamrtControl",
    defaultRegister: false,
    entry: "/appOfficeSamrtControl/",
    entryDev: "//localhost:9104/appOfficeSamrtControl/",
  },
  {
    name: "examination", // 考试管理
    routerBase: "/examination",
    defaultRegister: false,
    entry: "/appExamination/",
    entryDev: "//localhost:9101/appExamination/",
  },
  {
    name: "serviceFlowConfig", // 服务联盟-审批管理
    routerBase: "/serviceFlowConfig", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appServiceFlowConfig/",
    entryDev: "//localhost:9103/appServiceFlowConfig/",
  },
  {
    name: "energyConsumptioncp", // 能耗管理厦门体育馆
    routerBase: "/energyConsumptioncp", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appEnergyConsumptioncp/",
    entryDev: "//localhost:9018/appEnergyConsumptioncp/",
  },
  {
    name: "energyConsumptionxhcp", // 能耗管理cp复制xh
    routerBase: "/energyConsumptionxhcp", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appEnergyConsumptionxhcp/",
    entryDev: "//localhost:9100/appEnergyConsumptionxhcp/",
  },
  {
    name: "serviceAlarmHost", // 报警主机
    routerBase: "/serviceAlarmHost",
    defaultRegister: false,
    entry: "/appServiceAlarmHost/",
    entryDev: "//localhost:9110/appServiceAlarmHost/",
  },
  {
    name: "bimManage", // bim模型管理
    routerBase: "/bimManage",
    defaultRegister: false,
    entry: "/appBim/",
    entryDev: "//localhost:9088/appBim/",
  },
  {
    name: "smartParking", // 智慧停车
    routerBase: "/smartParking",
    defaultRegister: false,
    entry: "/appSmartParking/",
    entryDev: "//localhost:9119/appSmartParking/",
  },
  {
    name: "cantee", // 智慧餐厅
    routerBase: "/cantee",
    defaultRegister: false,
    entry: "/appCantee/",
    entryDev: "//localhost:9089/appCantee/",
  },
  {
    name: "constructionFifthBureau", // 中建五局研究院子应用
    routerBase: "/constructionFifthBureau",
    defaultRegister: false,
    entry: "/appConstructionFifthBureau/",
    entryDev: "//localhost:9088/appConstructionFifthBureau/",
  },
  {
    name: "spaceManagement", // 空间管理子应用
    routerBase: "/spaceManagement", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appSpaceManagement/",
    entryDev: "//localhost:9210/appSpaceManagement/",
  },
  {
    name: "shop", // 商铺模块
    routerBase: "/shop", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appShop/",
    entryDev: "//localhost:1617/appShop/",
  },
  {
    name: "paymentMerchant",  //支付管理子应用
    routerBase: '/paymentMerchant',  //子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appPaymentMerchant/",
    entryDev: "//localhost:9183/appPaymentMerchant/"
  },
  {
    name: "endbrain", // 端脑平台
    routerBase: "/endbrain", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appEndbrain/",
    entryDev: "//localhost:9055/appEndbrain/",
  },
  {
    name: "dataRoom", // 可视化平台
    routerBase: "/dataRoom", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appDataRoom/",
    entryDev: "//localhost:9055/appDataRoom/",
  },
  {
    name: "zhcfStaticPage", // 可视化平台
    routerBase: "/zhcfStaticPage", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appZhcfStaticPage/",
    entryDev: "//localhost:9064/appZhcfStaticPage/",
  },
  {
    name: "jqStaticPage", // 景区静态页面
    routerBase: "/jqStaticPage", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/FrontJqStaticPage/",
    entryDev: "//localhost:9065/FrontJqStaticPage/",
  },
  {
    name: "uav", // 无人机平台
    routerBase: "/uav", // 子应用激活的规则（会根据路由进行匹配）
    defaultRegister: false,
    entry: "/appUav/",
    entryDev: "//localhost:9529/appUav/",
  },
];
